"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledModalWrapper = styled_components_1.default.div `
  position: fixed;
  z-index: 1100;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
`;
const StyledModalBackground = styled_components_1.default.div `
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1;
`;
const RotaBackgroundModal = ({ handleClose, children }) => {
    return (react_1.default.createElement(StyledModalWrapper, null,
        react_1.default.createElement(StyledModalBackground, { onClick: handleClose, "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description" }, children)));
};
exports.default = RotaBackgroundModal;
